module.exports = __webpack_public_path__ + "img/icon-member.0b29b117.svg";